import Home from './Home.sync-postback.vue'

export default {
  Home
}